import { render, staticRenderFns } from "./ContaConfiguracao.vue?vue&type=template&id=083debdc&"
import script from "./ContaConfiguracao.vue?vue&type=script&lang=js&"
export * from "./ContaConfiguracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports